import { CheckboxGroup } from '@medly-components/core';
import { InjectClassName } from '@medly-components/utils';
import styled from 'styled-components';

export const MedlyFormWrapper = styled(InjectClassName)`
    input::-webkit-calendar-picker-indicator {
        display: none;
    }

    ${CheckboxGroup.Style} {
        & > span {
            margin: 0;
        }
        & > div {
            display: flex;
            flex-wrap: wrap;
        }
    }

    @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
        & > div {
            grid-column: 1 / -1;

            & > button {
                width: 100%;
            }
        }
    }
`;
